<template>
  <div>
    <div
      class="
        text-sm
        cursor-pointer
        mb-2
        rounded-t
        mailform-pages-tag-wrapper
      "
      :data-default="item.is_default"
    >
      <div
        v-if="item.status == 1 || type == 'personal'"
        class="h-44 relative rounded-t overflow-hidden"
      >
        <div
          class="absolute w-full h-full bg-black-transparent opacity-0 hover:opacity-100 flex items-center justify-center"
        >
          <div class="flex">
            <gd-button
              class="font-semibold"
              size="md"
              variant="primary"
              @click="useItem(true)"
              >
                {{ $t('frontend_use') }}
              </gd-button>
          </div>
        </div>
        <img :src="item.thumbnail" alt="" class="w-full" />
      </div>

      <div v-else class="h-44 relative rounded-t overflow-hidden">
        <div
          class="absolute w-full h-full bg-black-transparent opacity-0 hover:opacity-100 flex items-center justify-center"
        >
          <div class="flex">
            <gd-button
              class="font-semibold"
              size="md"
              variant="primary"
              @click="useItem(true)"
              >
                {{ $t('frontend_use') }}
              </gd-button>
          </div>
        </div>
        <img :src="item.thumbnail" alt="" class="w-full" />
      </div>

      <div class="p-3 rounded-b bg-secondary">
        <div v-if="!editMode" class="flex justify-between items-center">
          <div class="w-56 flex flex-1 items-center justify-between">
            <div class="flex flex-1">
              <div
                class="truncate"
                v-tooltip="{ classes: 'custom-tooltip', content: item.name }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <drop-menu
            v-if="type == 'personal'"
            :menu-items="getMenuItems()"
            dropMenuClass="mt-0 absolute right-0 z-10"
            variant="dark"
            small
            smallIcon
          >
          </drop-menu>
        </div>
        <div v-if="editMode">
          <text-input
            class="mb-3"
            variant="dark"
            v-model="templateName"
          />
          <div class="flex gap-2">
            <gd-button
              variant="primary"
              size="sm"
              @click="updateTemplate"
            >
              {{ $t('frontend_update') }}
            </gd-button>
            <gd-button
              size="sm"
              @click="editMode = false"
            >
              {{ $t('frontend_cancel') }}
            </gd-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import DropdownIcon from '@groovepages/gd-ui-kit/assets/dropdown-dots.svg';
import { VTooltip } from 'v-tooltip';

export default {
  name: 'TemplateItem',
  props: {
    item: {},
    type: {},
  },
  data() {
    return {
      templateName: this.item.name,
      editMode: false,
      DropdownIcon,
    };
  },
  
  directives: { tooltip: VTooltip },
  watch: {
    item: {
      handler(newVal) {
        this.templateName = newVal.name;
      }
    },
  },
  methods: {
    async useItem() {
      this.$emit("useTemplate", this.item);
    },

    // updated the template name
    async updateTemplate() {
      // create template object
      const template = Object.assign({}, this.item);

      // update template name
      template.name = this.templateName;

      // update template
      await this.$store.dispatch('forms/updateTemplate', template);

      // close edit mode
      this.editMode = false;
    },

    // get menu items
    getMenuItems() {
      const arr = [
        {
          text: this.$t('frontend_rename'),
          callback: () => {
            this.editMode = true;
          },
        },
      ];

      arr.push({
        text: this.$t('frontend_delete'),
        callback: () => {
          this.$emit("deleteTemplate", this.item);
        },
      });

      return arr;
    },
  },
};
</script>
